import { getProviderSectionRAGStats } from "root/DataFunctions/ChartFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getRAGDataPoints } from "root/Dashboard/DashboardPanelProviderRAGBarStats";
import { runSchool360Report } from "root/Reporting/School360ReportGenerate";
import { runSchoolReport } from "root/Reporting/SchoolReportGenerate";
import { SurveyType } from "root/Contexts/GlobalProvider";


export const runReport = ( enc_provider_id, provider_name, academic_year, survey_type, fullReport, pdfParams ) =>
{
    const year = academic_year === undefined ? 'current' : academic_year ;

    getProviderSectionRAGStats(enc_provider_id, year, survey_type,(response) =>
    {
        const reportData = getDataFromResponse(response);

        const graphData = getRAGDataPoints ( reportData, null ) ;

        const getVariableData = ( survey_type, value ) =>
        {
            const rval = {
                S360:
                    {
                        graph_header: 'Rag Status by Key Area',
                        graph_interval: 5
                    },
                S175:
                    {
                        graph_header: 'Rag Status by Standard',
                        graph_interval: 2
                    }
            }
            return rval[survey_type][value] ;
        }

        const graph_header = getVariableData ( survey_type, 'graph_header') ;

        const graph_interval = getVariableData ( survey_type, 'graph_interval') ;

        let options = {
            backgroundColor: '#FFFFFF',
            animationEnabled: false,
            exportEnabled: false,
            width: 800,
            title: {
                text: graph_header,
                fontColor: '#333',
                fontSize: 18,
                fontWeight: 'lighter',
                fontFamily: 'tahoma',
                padding: 20
            },
            axisX:{
                title:'',
                titleFontColor: '#333',
                titleFontSize: 14,
                titleFontFamily: 'tahoma',
                margin: 50,
                tickLength: 0
            },
            axisY: {
                title: "Questions",
                interlacedColor: "white",
                interval: graph_interval,
                titleFontSize: 14,
                gridColor: "white",
                titleFontFamily: 'tahoma',
                tickLength: 0
            },
            legend: {
                verticalAlign: "center",
                horizontalAlign: "right",
                reversed: true,
                cursor: "pointer",
                fontSize: 16,
            },
            toolTip: {
                shared: true
            },

            data: graphData
        };

        const chart = new CanvasJS.Chart("chartdiv", options);

        chart.render();

        const base64Image = chart.canvas.toDataURL();

        runSchoolReport(  enc_provider_id, year,  { survey_type: survey_type, pdfParams: pdfParams, data: reportData, provider_name: provider_name, image: base64Image, width: chart.canvas.width, height: chart.canvas.height }, fullReport );

    });
}